define.alias("shared/components/shared/wizard/slide/body", "media/components/shared/wizard/slide/body");